import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import './GeoLocation.scss';
import { GoogleMapReactKey } from '../../utility/environment_config';

// const Marker = ({ text }) => <div className='geo-pin'>
//     {/* <i class="fa fa-map-marker" aria-hidden="true"></i>{text} */}
// </div>;

const Marker = ({ text }) =>

    <i className="fa fa-map-marker location-pin" aria-hidden="true"></i>;


class CustomGoogleMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            center: {
                lat: this.props.lat,
                lng: this.props.lng
            },
            zoom: 15
        }

        this.onClickEvent = this.onClickEvent.bind(this);
    };

    onClickEvent(e) {
        console.log(e)
        this.setState({
            center: {
                lat: e.lat,
                lng: e.lng
            }
        })

        this.props.setCustomerSelectedGeocoding({
            lat: e.lat,
            lng: e.lng
        })
    }

    render() {
        return (
            // Important! Always set the container height explicitly
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: `${GoogleMapReactKey}`,
                        language: 'en'
                    }}
                    center={this.state.center}
                    defaultZoom={this.state.zoom}
                    onClick={this.onClickEvent}
                    options={{ fullscreenControl: false, zoomControl: this.props.isMobile ? false : true, mapTypeControl: true }}
                >
                    <Marker
                        lat={this.state.center.lat}
                        lng={this.state.center.lng}
                        text="Delivery Location"
                    />
                </GoogleMapReact>
            </div>
        );
    }
}

export default CustomGoogleMap;